module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape-2-area-dbb81c41b1a39fef5ee953ef02fdd194.jpg";